"use client";
import {
  useComboboxStore
} from "../__chunks/DLLQM6DZ.js";
import {
  ComboboxContextProvider
} from "../__chunks/N4X7J4OQ.js";
import "../__chunks/WYDDZRWN.js";
import "../__chunks/ZR5N62ZV.js";
import "../__chunks/LGWSZOP2.js";
import "../__chunks/QFI3MCMR.js";
import "../__chunks/6LTHW2TQ.js";
import "../__chunks/5B3U64HV.js";
import "../__chunks/IWHI6Y45.js";
import "../__chunks/RG6J4TID.js";
import "../__chunks/GUCZNEAD.js";
import "../__chunks/JNGHG5BN.js";
import "../__chunks/2KACNUKS.js";
import "../__chunks/ZIX5D53S.js";
import "../__chunks/PWUXK5IM.js";
import "../__chunks/WOWUAP42.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/combobox/combobox-provider.tsx
import { jsx } from "react/jsx-runtime";
function ComboboxProvider(props = {}) {
  const store = useComboboxStore(props);
  return /* @__PURE__ */ jsx(ComboboxContextProvider, { value: store, children: props.children });
}
export {
  ComboboxProvider
};
